// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet producten-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfProductenProductMaatschappijGetAllProductmaatschappijenProduct } from '../model/collectionResultOfProductenProductMaatschappijGetAllProductmaatschappijenProduct';

import type { Result1OfProductenProductmaatschappijGetProductmaatschappijMeldingDto } from '../model/result1OfProductenProductmaatschappijGetProductmaatschappijMeldingDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Producten.ProductenInzien</li></ul>
 * @summary Geeft de melding terug die op een productmaatschappij is ingeregeld.
 */
export const productMaatschappijGetMelding = (
  productmaatschappijId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  productmaatschappijId = unref(productmaatschappijId);

  return customInstance<Result1OfProductenProductmaatschappijGetProductmaatschappijMeldingDto>(
    {
      url: `/api/public/v1/productmaatschappij/${productmaatschappijId}/melding`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getProductMaatschappijGetMeldingQueryKey = (
  productmaatschappijId: MaybeRef<string | undefined | null>,
) => {
  return ['api', 'public', 'v1', 'productmaatschappij', productmaatschappijId, 'melding'] as const;
};

export const getProductMaatschappijGetMeldingQueryOptions = <
  TData = Awaited<ReturnType<typeof productMaatschappijGetMelding>>,
  TError = ErrorType<void>,
>(
  productmaatschappijId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof productMaatschappijGetMelding>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getProductMaatschappijGetMeldingQueryKey(productmaatschappijId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof productMaatschappijGetMelding>>> = ({
    signal,
  }) => productMaatschappijGetMelding(productmaatschappijId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => unref(productmaatschappijId) !== null && unref(productmaatschappijId) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof productMaatschappijGetMelding>>, TError, TData>;
};

export type ProductMaatschappijGetMeldingQueryResult = NonNullable<
  Awaited<ReturnType<typeof productMaatschappijGetMelding>>
>;
export type ProductMaatschappijGetMeldingQueryError = ErrorType<void>;

/**
 * @summary Geeft de melding terug die op een productmaatschappij is ingeregeld.
 */

export function useProductMaatschappijGetMelding<
  TData = Awaited<ReturnType<typeof productMaatschappijGetMelding>>,
  TError = ErrorType<void>,
>(
  productmaatschappijId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof productMaatschappijGetMelding>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductMaatschappijGetMeldingQueryOptions(productmaatschappijId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Geeft alle productmaatschappijen gegroepeerd per product terug
 */
export const productMaatschappijGetAllProductmaatschappijen = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfProductenProductMaatschappijGetAllProductmaatschappijenProduct>(
    { url: `/api/public/v1/productmaatschappij`, method: 'GET', signal },
    options,
  );
};

export const getProductMaatschappijGetAllProductmaatschappijenQueryKey = () => {
  return ['api', 'public', 'v1', 'productmaatschappij'] as const;
};

export const getProductMaatschappijGetAllProductmaatschappijenQueryOptions = <
  TData = Awaited<ReturnType<typeof productMaatschappijGetAllProductmaatschappijen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof productMaatschappijGetAllProductmaatschappijen>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getProductMaatschappijGetAllProductmaatschappijenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productMaatschappijGetAllProductmaatschappijen>>
  > = ({ signal }) => productMaatschappijGetAllProductmaatschappijen(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productMaatschappijGetAllProductmaatschappijen>>,
    TError,
    TData
  >;
};

export type ProductMaatschappijGetAllProductmaatschappijenQueryResult = NonNullable<
  Awaited<ReturnType<typeof productMaatschappijGetAllProductmaatschappijen>>
>;
export type ProductMaatschappijGetAllProductmaatschappijenQueryError = ErrorType<unknown>;

/**
 * @summary Geeft alle productmaatschappijen gegroepeerd per product terug
 */

export function useProductMaatschappijGetAllProductmaatschappijen<
  TData = Awaited<ReturnType<typeof productMaatschappijGetAllProductmaatschappijen>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productMaatschappijGetAllProductmaatschappijen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductMaatschappijGetAllProductmaatschappijenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
